<div class="toolbar-user-container">
  <button
    *ngIf="!user"
    mat-button
    class="toolbar-user-btn"
    [ngStyle.xs]="{ 'min-width': '70px' }"
  >
    <span class="flex flex-row items-center">
      <img
        class="avatar"
        src="./assets/images/avatars/noavatar.png"
        alt="avatar"
      />
      <span class="name d-none d-gt-xs-inline">{{ "menu.log_in" | translate }}</span>
    </span>
  </button>
  <button
    *ngIf="user"
    mat-button
    (click)="isOpen = !isOpen"
    class="toolbar-user-btn"
    [class.open]="isOpen"
    [ngStyle.xs]="{ 'min-width': '70px' }"
  >
    <div class="flex flex-row items-center justify-center gap-md">
      <img class="avatar" src="./assets/profile.jpg" alt="avatar" />
      <div class="name flex flex-column items-center justify-center">
        {{ user?.given_name }}
        <cite class="active-role flex items-center justify-center"
          >{{ activeTenant | uppercase }} - {{ activeRole }}</cite
        >
      </div>
      <mat-icon class="icon">keyboard_arrow_down</mat-icon>
    </div>
  </button>
  <div *ngIf="user" class="dropdown mat-elevation-z1" [class.open]="isOpen">
    <div class="content">
      <mat-nav-list>
        <!-- TEMP: For B2C migration -->
        <!-- <mat-list-item (click)="goProfile()">
          <a matLine>{{ "menu.my_profile" | translate }}</a>
          <button mat-icon-button>
            <mat-icon>account_circle</mat-icon>
          </button>
        </mat-list-item> -->
        <mat-list-item (click)="changeTenant()" *ngIf="enableTenantChange">
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.tenant_list" | translate }}</a>
            <mat-icon>language</mat-icon>
          </div>
        </mat-list-item>
        <mat-list-item
          (click)="changeProfile()"
          *ngIf="user?.rolesAndModules.length > 1"
        >
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.roles" | translate }}</a>
            <mat-icon>compare_arrows</mat-icon>
          </div>
        </mat-list-item>
        <mat-list-item (click)="goAdminTool()" *ngIf="enableAdminTool">
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.admin_tool" | translate }}</a>
            <mat-icon>settings</mat-icon>
          </div>
        </mat-list-item>
        <mat-list-item
          *ngIf="enableMailingList"
          routerLink="/cube/mailing-list"
          routerLinkActive="active"
        >
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.setup_mailing_list" | translate }}</a>
            <mat-icon>email</mat-icon>
          </div>
        </mat-list-item>
        <mat-list-item
          *ngIf="enableAppMobile"
          routerLink="/cube/qr-code"
          routerLinkActive="active"
        >
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.mobile_pairing" | translate }}</a>
            <mat-icon>phonelink_ring</mat-icon>
          </div>
        </mat-list-item>
        <mat-list-item (click)="openSupportPage()">
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.support" | translate }}</a>
            <mat-icon>headset_mic</mat-icon>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <div class="flex justify-between items-center width-full">
            <a
              matLine
              *ngrxLet="language$ as language"
              (click)="changeLang(language == 'en' ? 'it' : 'en')"
            >
              {{ language == "en" ? "Italian - it" : "English - en" }}</a
            >
            <mat-icon>language</mat-icon>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="changeTheme()">
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.change_theme" | translate }}</a>
            <mat-icon>invert_colors</mat-icon>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="doLogout()">
          <div class="flex justify-between items-center width-full">
            <a matLine>{{ "menu.logout" | translate }}</a>
            <mat-icon>exit_to_app</mat-icon>
          </div>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </div>
</div>
